import { GET_ORDER_INFO, ORDER_INFO_INLINE_LOADER } from '../actionTypes/OrderActionTypes';

export default function OrderInfoReducer(state = {}, action) {
    // NOSONAR
    switch (action.type) {
        case GET_ORDER_INFO:
            return { ...state, ...action.payload };
        case ORDER_INFO_INLINE_LOADER:
            return { ...state, showInlineLoader: action.payload };
        default:
            return state;
    }
}
